export const PAGE_VERSIONS = {
    1: 'Baseline',
    4: 'v4',
    5: 'v5',
    6: 'v6',
    DEFAULT: 'Baseline'
}

export const HOMEPAGE_CONFIG = {
    1: 'HomePage_v3',
    4: 'HomePage_v4',
    5: 'HomePage_v5',
    6: 'HomePage_v6',
    DEFAULT: 'HomePage_v3'
}

export const HOMEPAGE_CONTENT = {
    1: 'home_v3',
    4: 'home_v4',
    5: 'home_v5',
    6: 'home_v6',
    default: 'home_v3'
}
